import { decodeQueryString, encodeQueryString } from '../../../../app/queryString'
import { SubMenuTabs } from '../../../components/SubMenu/SubMenuTabs'
import { OptionsSubpage, OptionsView } from '../../options/types'
import { QuoteSubview } from '../types'

const OPTIONS_SECTION_LABELS = {
  [QuoteSubview.OptionsChain]: 'Prices',
  [QuoteSubview.OptionsVolatility]: 'Volatility & Greeks',
}

const OPTIONS_MENU_TABS: Array<keyof typeof OPTIONS_SECTION_LABELS> = [
  QuoteSubview.OptionsChain,
  QuoteSubview.OptionsVolatility,
]

function getProperOV(ty: string, ov: string): string {
  if (ty === OptionsSubpage.Volatility && ov === OptionsView.Plot) {
    return OptionsView.ChainByDate
  }
  return ov
}

function getOptionsMenuTabs() {
  const searchParams = decodeQueryString()

  return OPTIONS_MENU_TABS.map((value) => ({
    label: OPTIONS_SECTION_LABELS[value],
    href: `/quote.ashx?${encodeQueryString({
      ...searchParams,
      ty: value,
      ov: getProperOV(value, searchParams.ov),
    })}`,
    isActive: searchParams.ty === value,
    reloadDocument: true,
  }))
}

export function QuoteOptionsTabMenu() {
  return <SubMenuTabs items={getOptionsMenuTabs()} />
}
